/**
 * Şəkil ölçüsünü optimallaşdırır: Supabase Storage şəkilləri üçün
 * server tərəfdə kiçildilmiş (və brauzer dəstəkləyirsə WebP) variant qaytarır.
 * Digər (lokal/asset) linklər olduğu kimi qalır.
 */
const STORAGE_RE = /\/storage\/v1\/(object|render\/image)\/(sign|public)\//;

export function optimizedImage(url: string, width: number, quality = 65): string {
  if (!url || !STORAGE_RE.test(url)) return url;
  const rendered = url.replace("/storage/v1/object/", "/storage/v1/render/image/");
  const sep = rendered.includes("?") ? "&" : "?";
  if (rendered.includes("width=")) return rendered;
  return `${rendered}${sep}width=${width}&resize=contain&quality=${quality}`;
}

/** Retina üçün 1x/2x srcset */
export function imageSrcSet(url: string, width: number, quality = 65): string | undefined {
  if (!url || !STORAGE_RE.test(url)) return undefined;
  return `${optimizedImage(url, width, quality)} 1x, ${optimizedImage(url, width * 2, quality)} 2x`;
}
